/**
 * Platform detection helpers.
 *
 * Centralizes the only user-agent sniffing in the app. Call these
 * instead of inlining UA checks so the surface is easy to audit and
 * replace (UA-CH, etc.) later.
 */

export function isIOS() {
  if (typeof navigator === 'undefined') return false;
  const ua = navigator.userAgent || '';
  // iPadOS 13+ reports as Mac; distinguish by touch support.
  const iPadOS = /Macintosh/.test(ua) && navigator.maxTouchPoints > 1;
  return /iPhone|iPad|iPod/.test(ua) || iPadOS;
}

export function isAndroid() {
  if (typeof navigator === 'undefined') return false;
  return /Android/.test(navigator.userAgent || '');
}

/**
 * True when the page is launched from the home screen (PWA mode) on
 * either platform. Falls back gracefully when matchMedia is absent
 * (jsdom).
 */
export function isStandalone() {
  if (typeof window === 'undefined') return false;
  if (typeof window.matchMedia === 'function') {
    try {
      if (window.matchMedia('(display-mode: standalone)').matches) return true;
    } catch (_e) { /* ignore */ }
  }
  // iOS Safari exposes a non-standard flag.
  return navigator.standalone === true;
}
